<script setup lang="ts">
    import { ref } from 'vue';

    const open = ref<boolean>(false);
</script>
<template>
    <span class="relative cursor-pointer text-body-bold hover:underline" @click="open = !open">
        ...
        <span
            v-if="open"
            class="ellipsis-tooltip bg-white rounded-sm text-xs px-2 py-1 absolute whitespace-nowrap left-1/2 transform -translate-x-1/2 top-full border-1 border-gray-lightest mt-1"
            aria-hidden="true"
        >
            <slot name="content" />
        </span>
    </span>
</template>
<style>
    .ellipsis-tooltip::after {
        content: '';
        position: absolute;
        width: 7px;
        height: 7px;
        border-top: 1px solid #ebebeb;
        border-right: 1px solid #ebebeb;
        background-color: #fff;
        top: -4px;
        left: 50%;
        transform: translateX(-50%) rotate(-45deg);
    }
</style>
